import { Loader } from "@/components/loader/loader.component";

export const ProductAccessoriesLoader = () => {
  return (
    <section
      data-testid="product-accessories-loader"
      className="flex flex-1 items-center justify-center">
      <Loader loading size="lg" variant="secondary" />
    </section>
  );
};
